package editor.capture

enum class CaptureMode(val friendlyName: String) {
    Outlines("Zeichnung"), Realistic("Realistisch")
}